// Supermove
import {Form} from '@supermove/hooks';
import {Datetime} from '@supermove/utils';

export type UserCalendarEventFormFieldsType = {
  userId: string;
  calendarId: string;
  title: string;
  description: string;
  startTime: Date;
  endTime: Date;
};

export type UserCalendarEventFormType = Form<{
  userCalendarEventForm: UserCalendarEventFormFieldsType;
}>;

const _new = (userId: string, calendarId: string) => ({
  userId,
  calendarId,
  title: '',
  description: '',
  startTime: Datetime.now.toDate(),
  endTime: Datetime.now.toDate(),
});

const toMutation = ({
  userId,
  calendarId,
  title,
  description,
  startTime,
  endTime,
}: UserCalendarEventFormFieldsType) => ({
  userId,
  calendarId,
  title,
  description,
  startTime,
  endTime,
});

const UserCalendarEventForm = {
  new: _new,
  toMutation,
};

export default UserCalendarEventForm;
